import { StyleSheet, View, type ViewProps } from "react-native";

import { radii, useThemedStyles, type ThemeColors } from "~/styles/theme";

export function Skeleton({ style, ...props }: ViewProps) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View
      accessibilityElementsHidden
      style={[stylesheet.skeleton, style]}
      {...props}
    />
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    skeleton: {
      minHeight: 16,
      borderRadius: radii.m,
      backgroundColor: colors.surface,
    },
  });
